import React, { Component } from "react";
import { NavLink } from "react-router-dom";

/**
 * Footer component with quick links and application information
 * Provides navigation links and additional resources
 */
export class Footer extends Component {
    render() {
        return (
            <footer className="bg-dark text-light mt-5">
                <div className="container py-4">
                    <div className="row">
                        <div className="col-md-8 text-left">
                            <h5 className="text-white mb-3">
                                <i className="fab fa-react mr-2"></i>
                                React Features Demo
                            </h5>
                            <p className="text-light">
                                A comprehensive demonstration of Higher-Order Component patterns
                                and modern React development practices.
                            </p>
                        </div>

                        <div className="col-md-2 text-left">
                            <h5 className="text-white mb-3">
                                <i className="fas fa-link mr-2"></i>
                                Quick Links
                            </h5>
                            <ul className="list-unstyled">
                                <li className="mb-2">
                                    <NavLink
                                        to="/parent"
                                        className="text-light d-flex align-items-center"
                                        aria-label="Go to Parent page"
                                    >
                                        <i className="fas fa-user-tie mr-2"></i>
                                        Parent Profile
                                    </NavLink>
                                </li>
                                <li className="mb-2">
                                    <NavLink
                                        to="/childa"
                                        className="text-light d-flex align-items-center"
                                        aria-label="Go to ChildA page"
                                    >
                                        <i className="fas fa-baby mr-2"></i>
                                        ChildA Profile
                                    </NavLink>
                                </li>
                                <li className="mb-2">
                                    <NavLink
                                        to="/childb"
                                        className="text-light d-flex align-items-center"
                                        aria-label="Go to ChildB page"
                                    >
                                        <i className="fas fa-child mr-2"></i>
                                        ChildB Profile
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to="/dev-status"
                                        className="text-light d-flex align-items-center"
                                        aria-label="Go to Dev Status page"
                                    >
                                        <i className="fas fa-code-branch mr-2"></i>
                                        Dev Status
                                    </NavLink>
                                </li>
                            </ul>
                        </div>

                        <div className="col-md-2 text-left">
                            <h5 className="text-white mb-3">
                                <i className="fas fa-code mr-2"></i>
                                Resources
                            </h5>
                            <ul className="list-unstyled">
                                <li className="mb-2">
                                    <a
                                        href="https://reactjs.org/"
                                        className="text-light d-flex align-items-center"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="React Documentation"
                                    >
                                        <i className="fab fa-react mr-2"></i>
                                        React Documentation
                                    </a>
                                </li>
                                <li className="mb-2">
                                    <a
                                        href="https://reactrouter.com/"
                                        className="text-light d-flex align-items-center"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="React Router Documentation"
                                    >
                                        <i className="fas fa-route mr-2"></i>
                                        React Router
                                    </a>
                                </li>
                                <li className="mb-2">
                                    <a
                                        href="https://getbootstrap.com/"
                                        className="text-light d-flex align-items-center"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="Bootstrap Documentation"
                                    >
                                        <i className="fab fa-bootstrap mr-2"></i>
                                        Bootstrap
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://fontawesome.com/"
                                        className="text-light d-flex align-items-center"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="Font Awesome Icons"
                                    >
                                        <i className="fas fa-icons mr-2"></i>
                                        Font Awesome
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <hr className="my-4 bg-light" />

                    <div className="row align-items-center">
                        <div className="col-md-6 text-left">
                            <p className="mb-0 text-light">
                                <i className="fas fa-copyright mr-1"></i>
                                2026 React Features Demo. Built with React & Bootstrap.
                            </p>
                        </div>
                        <div className="col-md-6 text-md-right">
                            <small className="text-muted">
                                <i className="fas fa-magic mr-1"></i>
                                Powered by Higher-Order Components
                            </small>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;